/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Somethingwentwrong2Inputs */

const en_somethingwentwrong2 = /** @type {(inputs: Somethingwentwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

const de_somethingwentwrong2 = /** @type {(inputs: Somethingwentwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Somethingwentwrong2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const somethingwentwrong2 = /** @type {((inputs?: Somethingwentwrong2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Somethingwentwrong2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_somethingwentwrong2(inputs)
	return de_somethingwentwrong2(inputs)
});
export { somethingwentwrong2 as "somethingWentWrong" }